export enum TutorialVideoEnum {
  REVIT_GLOBAL = "REVIT_GLOBAL",
  ARCHICAD_INTRODUCTION = "ARCHICAD_INTRODUCTION",
  ARCHICAD_GLOBAL = "ARCHICAD_GLOBAL",
}
